import $ from 'jquery'
import userApi from '@/api/userApi'
import app from '../main'
import config from '../config'
import { ApiErrors } from '@/types/codes';

export interface ITokenData {
  access_token: string
  expires_in: number
  expire_time: number
  refresh_token: string
  scope: string
  token_type: string
}

class TokenManager {
  private token: ITokenData
  private refreshPromise: Promise<any> | null = null
  /**
   * 是否正在刷新token，如果正在刷新，则不进行并发刷新token，避免多次刷新导致之前的token失效
   */
  private refreshing: boolean = false
  public HttpHeaderName: string = 'Authorization'

  public getToken(defValue: ITokenData | null = null): ITokenData {
    if (this.token) {
      return this.token
    }
    try {
      this.token = JSON.parse(localStorage.getItem('token')) || defValue
      return this.token
    } catch {
      this.deleteToken()
    }
    return defValue
  }

  public setToken(data: ITokenData): void {
    this.token = data
    localStorage.setItem('token', JSON.stringify(data))
  }

  public deleteToken(): void {
    this.token = null
    localStorage.removeItem('token')
  }


  /**
   * 刷新token
   * 为了保证在刷新token时，又发起了其他ajax请求，导致出现token失效的问题，故使用promise来保证顺序。
   */
  public refreshToken(): Promise<any> {
    if (this.refreshPromise != null && this.refreshing) {
      return this.refreshPromise
    }
    let self = this
    this.refreshing = true
    this.refreshPromise = new Promise((resolve: any, reject: any) => {
      let state = this.getState()
      if (state == TokenState.None || state == TokenState.Expired) {
        reject(state)
      } else if (state == TokenState.Healthy) {
        resolve(state)
      } else if (state == TokenState.NeedRefresh) {
        let token = this.getToken()
        let params = {
          client_id: 'rest',
          client_secret: 'rest',
          grant_type: 'refresh_token',
          refresh_token: token ? token.refresh_token : ''
        }
        $.ajax({
          url: config.baseURL + 'oauth/token',
          dataType: 'json',
          method: 'GET',
          data: params,
          success: (res => {
            if (res.code) {
              if (res.code == ApiErrors.TokenExpired || res.code == ApiErrors.RefreshTokenExpired) {
                console.log('失败')
                reject(res)
              }
            } else {
              console.log('成功')
              this.setToken(res)
              resolve(res)
            }
          }),
          error: (res => {
            reject(res)
            if (res.responseJSON) {
              let code = res.responseJSON.code
              if (code == ApiErrors.TokenExpired || code == ApiErrors.RefreshTokenExpired) {

              }
            }
          })
        })
      } else {
        throw new Error('未处理的token状态')
      }
    }).finally(() => {
      self.refreshing = false
    })
    return this.refreshPromise
  }

  public getState(): TokenState {
    let token = this.getToken()
    if (token == null) {
      return TokenState.None
    }
    let now = new Date().getTime()
    if (now >= token.expire_time) {
      let autoLogin = localStorage.getItem('autoLogin') == 'true'
      return autoLogin ? TokenState.NeedRefresh : TokenState.Expired
    }
    if (now >= (token.expire_time - 20 * 60 * 1000)) {
      return TokenState.NeedRefresh
    }
    return TokenState.Healthy
  }

  public goLogin(): void {
    app.$warning({
      title: '登录失效',
      content: '请重新登录',
      onOk() {
        window.location.href = '/user/#/login'
      },
    });
  }

  public getAuthorizationString() {
    let token = this.getToken()
    if (token) {
      return token.token_type + ' ' + token.access_token
    }
    return ''
  }

}

export enum TokenState {
  /**
   * 没有token
   */
  None = 1,
  /**
   * 已过期
   */
  Expired = 2,
  /**
   * 需要刷新
   */
  NeedRefresh = 3,
  /**
   * 正常
   */
  Healthy = 4
}

export let tokenManager = new TokenManager()
